import { Link, useRouterState } from "@tanstack/react-router";
import { Phone, MessageCircle } from "lucide-react";
import { SITE } from "@/config/site";

/**
 * Bottom-fixed CTA bar for mobile only. Lets visitors call, WhatsApp, or
 * jump to the quote form from any page. Hidden on /quote (the destination).
 */
export function MobileStickyCTA() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  if (pathname.startsWith("/quote")) return null;

  return (
    <>
      {/* Spacer so page content isn't hidden behind the bar */}
      <div aria-hidden className="h-20 lg:hidden" />
      <div
        className="fixed bottom-0 inset-x-0 z-40 lg:hidden border-t border-border bg-background/95 backdrop-blur-md shadow-[0_-6px_20px_-10px_rgba(0,0,0,0.15)]"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        <div className="container-x py-2.5 grid grid-cols-[auto_auto_1fr] items-center gap-2">
          <a
            href={`tel:${SITE.phone}`}
            aria-label="Call IZHUB Cleaning"
            className="grid h-11 w-11 place-items-center rounded-full border border-border text-foreground/80 hover:text-primary transition-colors"
          >
            <Phone className="h-4.5 w-4.5" />
          </a>
          <a
            href={SITE.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp IZHUB Cleaning"
            className="grid h-11 w-11 place-items-center rounded-full border border-border text-foreground/80 hover:text-primary transition-colors"
          >
            <MessageCircle className="h-4.5 w-4.5" />
          </a>
          <Link
            to="/quote"
            className="btn-primary w-full justify-center text-sm !py-3"
          >
            Get a Quote
          </Link>
        </div>
      </div>
    </>
  );
}
